import { ServiceNowEntity } from '../enums/ServiceNowEntity';

export const DIGITAL_CHANNEL_TYPE = {
    EMAIL: 'EMAIL',
    SMS: 'DIGITAL_SMS',
    ENGAGE_MESSAGING: 'ENGAGE_MESSAGING',
    WHATS_APP: 'WHATS_APP',
};

export const tableNameMap = {
    Contact: ServiceNowEntity.CONTACT,
    Account: ServiceNowEntity.ACCOUNT,
    Consumer: ServiceNowEntity.CONSUMER,
    Case: ServiceNowEntity.CASE,
    CaseTask: ServiceNowEntity.CASE_TASK,
    User: ServiceNowEntity.USER,
};

export const RCX_IFRAME_WIDTH = 300;
export const SECOND_IFRAME_WIDTH = 520;
export const IFRAME_TOGGLE_WIDTH = 16;

export const CALL_LOGGING_TYPE_KEY = 'CALL_LOGGING_TYPE';

export enum ScriptStatus {
    PENDING = 'pending',
    RUNNING = 'running',
}

export enum LOGGING_TYPE {
    INCIDENT = 'INCIDENT',
    INTERACTION = 'INTERACTION',
}
export const rcxNeedStateIdList = [
    'AVAILABLE',
    'ENGAGED',
    'TRANSITION',
    'RNA-STATE',
    'WORKING',
    'SUSPECT',
    'MONITORING',
    'OFFLINE',
    'NULL',
];

export const rcxDefaultStateIdList = ['AVAILABLE', 'WORKING', 'AWAY'];

export const NOT_SYNC_STATE = '0';
